import { render } from "./IconAirplane.vue?vue&type=template&id=122b4727"
import script from "./IconAirplane.vue?vue&type=script&lang=ts"
export * from "./IconAirplane.vue?vue&type=script&lang=ts"
script.render = render

export default script